export default class Alert {
    constructor(option) {
        this.apiManager = option.apiManager;
    }
    activeAlerts(params) {
        return this.apiManager.getActiveAlerts(params);
    }
    recurringAlerts(params) {
        params.autoReset = true;
        return this.apiManager.getActiveAlerts(params);
    }
    triggeredAlerts(params) {
        return this.apiManager.getTriggeredAlerts(params);
    }
    subscribeAlert(params) {
        return this.apiManager.subscribeAlert(params);
    }

    updateAlert(params) {
        return this.apiManager.updateAlert(params);
    }

    deleteAlert(params) {
        return this.apiManager.deleteAlert(params);
    }

    acknowledgeAlerts(params) {
        return this.apiManager.acknowledgeAlerts(params);
    }
    getAlertConfig(params) {
        return this.apiManager.getAlertConfig(params);
    }
    saveAlertConfig(params) {
        return this.apiManager.saveAlertConfig(params);
    }
}
